import React, { createContext, useCallback, useEffect, useState } from 'react'

export const ThemeContext = createContext()

const ThemeProvider = ({ location, children, scrollSmoother }) => {
  const [resetForm, setFormReset] = useState(false)

  const [showSplash, setShowSplash] = useState(true)

  const setResetForm = useCallback((v) => {
    setFormReset(v)
  }, [])

  useEffect(() => {
    if (showSplash && location.pathname !== '/') {
      setShowSplash(false)
    }
  }, [location, showSplash, setShowSplash])

  return (
    <ThemeContext.Provider
      value={{
        showSplash,
        setShowSplash,
        resetForm,
        setResetForm,
        scrollSmoother,
      }}
    >
      {children}
    </ThemeContext.Provider>
  )
}

export default ThemeProvider
